import React, {useState,useEffect} from 'react'
import firebase from '../../../firebase'
import { Link } from 'react-router-dom'
import numeral from 'numeral'
import moment from 'moment'
import _ from 'lodash'

const Item = (props) => {
    const {data} = props

    return (
        <tr>
            <td>{data.id}</td>
            <td>{moment(data.date).format('DD-MM-YYYY')}</td>
            <td>{data.providerName}</td>
            <td>{data.brandName}</td>
            <td>{numeral(data.total).format('$0,0.00')}</td>
            <td><Link to={`/compras/cotizaciones/${data.id}`}><i className="material-icons">chevron_right</i></Link></td>
        </tr>
    )
}

const PurchasesQuoteContainer = (props) => {
    const [quotations,setQuotations] = useState([])

    useEffect(() => {
        const initialMonth = moment(props.month,'MM-YYYY').startOf('month').valueOf()
        const endMonth = moment(props.month,'MM-YYYY').endOf('month').valueOf()
        if (initialMonth && endMonth) {
            firebase.getCollectionRealTime('quotations').where('date','<=',endMonth).where('date','>=',initialMonth).onSnapshot(snap => {
                const quotations = snap.docs.map(doc => doc.data())
                setQuotations(quotations)
            })
        }
    }, [props.month])

    const ordered = _.orderBy(quotations, ['date'],['desc'])

    return (
        <tbody>{
            Object.keys(ordered).map(key => <Item key={key} data={ordered[key]} />)
        }</tbody>
    )
}

const PurchasesQuote = () => {

    const [month,setMonth] = useState(undefined)

    useEffect(() => {
        const current = moment().format('MM-YYYY')
        setMonth(current)
    }, [])

    return (
        <div className="purchases-quote">
            <table>
                <thead>
                    <tr>
                        <th colSpan="6">
                            <div className="date-picker">
                                <button onClick={prevMonth}>
                                    <i className="material-icons">arrow_left</i>
                                </button>
                                <span>{month}</span>
                                <button onClick={nextMonth}>
                                    <i className="material-icons">arrow_right</i>
                                </button>
                            </div>
                        </th>
                    </tr>
                    <tr>
                        <th>Id</th>
                        <th>Fecha</th>
                        <th>Proveedor</th>
                        <th>Marca</th>
                        <th>Total</th>
                        <th>Ver</th>
                    </tr>
                </thead>
                <PurchasesQuoteContainer month={month} />
            </table>
        </div>
    )

    async function nextMonth() {
        try {
            const newMonth = moment(month, 'MM-YYYY').add(1,'month').format('MM-YYYY')
            setMonth(newMonth)
        } catch (error) {
            alert(error.message)
        }
    }
    async function prevMonth() {
        try {
            const newMonth = moment(month, 'MM-YYYY').subtract(1,'month').format('MM-YYYY')
            setMonth(newMonth)
        } catch (error) {
            alert(error.message)
        }
    }
}

export default PurchasesQuote